module.exports = __webpack_public_path__ + "static/karl-9ec85e7770d30885b1c4e7867a10ca14.png";